export default "__VITE_ASSET__B0oF4M5K__"